// extracted by mini-css-extract-plugin
export default {"blurredContent":"PaperDetails_blurredContent__Q8vgr","loginMessage":"PaperDetails_loginMessage__EKv6K"};